import { makeStyles } from '../../../../styles';
export const useCheckMarkStyles = makeStyles((theme) => ({
    notComplete: {
        boxSizing: 'content-box',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        borderRadius: '100%',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.colors.gray[200],
        color: theme.colors.gray[200],
        height: '20px',
        width: '20px',
        marginRight: '10px',
    },
    complete: {
        boxSizing: 'content-box',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        borderRadius: '100%',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.colors.success.main,
        color: theme.colors.success.main,
        height: '20px',
        width: '20px',
        marginRight: '10px',
    },
    materialIcon: {
        fontSize: '18px !important',
        verticalAlign: 'middle',
    },
}));
//# sourceMappingURL=CheckMark.styles.js.map